// extracted by mini-css-extract-plugin
module.exports = {"BuildingPhotos":"BuildingPhotos__BuildingPhotos__2M7uI","show-index":"BuildingPhotos__show-index__lTbcS","is-dot":"BuildingPhotos__is-dot__2cxdl"};